@import '../../styles/calendar.css';
@import '../../styles/buttons.css';

:host {
  display: block;
  position: relative;
  overflow: hidden;

  --slot-height: 18px;
  --column-header-height: calc(var(--slot-height) + 30px);
  --time-column-width: 80px;
  --border: #dadce0 1px dotted;
  --column-min-width: 80px;
}

.calendar {
  display: block;
  position: relative;
}

.calendar.large-slots { --slot-height: 36px; }
.calendar.medium-slots { --slot-height: 27px; }
.calendar.small-slots { --slot-height: 18px; }

.calendar-grid-slot {
  display: flex;
  height: var(--slot-height);
}


.calendar-grid-slot-label {
  width: 60px;
  font-size: 13px;
  color: #666;
  padding-right: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  top: calc(var(--slot-height) * -1 / 2);
  white-space: nowrap;
  cursor: default;
}

.calendar-grid-slot-label.secondary {
  color: #999;
  font-size: 11px;
}

.calendar-grid-slot-line {
  flex-grow: 1;
  border-top: var(--border);
}


.calendar-grid {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  display: flex;
}

.calendar-spacer {
  min-width: var(--time-column-width);
  height: calc(100% - var(--slot-height));
  border-right: var(--border);
}

.calendar-content {
  flex-grow: 1;
  position: relative;
  overflow-x: auto;
}

.calendar-content::-webkit-scrollbar {
  display: none;
}

.calendar-headers {
  display: flex;
}

.hidden-headers {
  visibility: hidden;
  width: calc(100% - var(--time-column-width));
  margin-left: auto;
}

.calendar-header {
  color: #666;
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-left: var(--border);
  min-width: var(--column-min-width);
  cursor: pointer;
  transition: background-color 0.15s ease-out;
  gap: 5px;
  padding: 10px 3px;
  min-height: 30px;
  box-sizing: border-box;
}

.calendar-header:hover {
  background-color: #00000005;
}

.calendar-header[hidden] {
  display: none;
}

.calendar-header:first-child {
  border-left: none;
}

.calendar-header-title {
  text-overflow: ellipsis;
  line-height: 1.2em;
  overflow: hidden;
}

.calendar-header-subtitle {
  font-size: 10px;
  letter-spacing: 1px;
  text-transform: uppercase;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 1.3em;
}

.calendar-columns {
  display: flex;
  width: 100%;
  position: relative;
}

.calendar-column {
  flex-grow: 1;
  flex-basis: 0;
  display: flex;
  flex-direction: column;
  text-align: center;
  border-left: var(--border);
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: var(--column-min-width);
  box-sizing: border-box;
}

.calendar-column[hidden] {
  display: none;
}

.calendar-column:first-child {
  border-left: none;
}

#selection {
  display: none;
  position: absolute;
  width: 100px;
  height: 100px;
  top: 0;
  left: 0;
  background: #fff;
  border: 1px solid;
  box-sizing: border-box;
}


.arrow-button-background {  
  position: absolute;
  top: 0px;
  z-index: 100;
  height: none;
  width: 60px;
  display: flex;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  transition: transform .2s ease-in-out;
}

.tambr-arrow-button {
  --arrow-button-size: 25px;
}

#scroll-left {
  left: calc(var(--time-column-width) + 1px);
  justify-content: flex-start;
  padding-left: 5px;
}

#scroll-right {
  right: 0;
  justify-content: flex-end;
  padding-right: 5px;
}


#scroll-left .tambr-arrow-button {
  transform: translateX(-20%);
}

#scroll-right .tambr-arrow-button {
  transform: translateX(20%);
}

.arrow-button-background.show { opacity: 1; visibility: visible; }

#scroll-right.arrow-button-background.show .tambr-arrow-button { transform: translateX(0); }

#scroll-left.arrow-button-background.show .tambr-arrow-button { transform: translateX(0); }